{
  "contactModal": {
    "delete": {
      "cancel": "Cancel",
      "confirm": "Delete",
      "error": {
        "contactWithInformationRequests": "Impossible to delete contact with assigned information requests",
        "default": "Error deleting contact",
        "title": "Error deleting contact"
      },
      "message": "Are you sure you want to delete the selected business partner? This action is irrevocable",
      "success": "Contact deleted successfully",
      "title": "Confirmation"
    }
  },
  "contacts": {
    "buttons": {
      "add": "New"
    },
    "table": {
      "headers": {
        "actions": "Actions",
        "email": "Contact Email",
        "id": "ID",
        "name": "Site name"
      }
    }
  },
  "productionSiteModal": {
    "actions": {
      "cancel": "Cancel",
      "delete": "Delete",
      "save": "Save"
    },
    "createTitle": "Create production site",
    "delete": {
      "cancel": "No",
      "confirm": "Yes",
      "message": "Are you sure you want to delete this production site?",
      "title": "Production site deleted"
    },
    "editTitle": "Edit production site",
    "errors": {
      "cityRequired": "City is required",
      "coordinatesMaxDecimals": "Latitude and longitude can have at most 6 decimal places",
      "countryMustBeValid": "Country must be valid",
      "internalCodeTooLong": "The internal code must be less than 32 characters",
      "nameRequired": "Name is required",
      "parentCompanyRequired": "Parent company is required",
      "postalCodeTooShort": "Postal code must be at least 3 characters",
      "streetRequired": "Street is required",
      "streetTooShort": "Street must be at least 3 characters"
    },
    "labels": {
      "city": "City",
      "country": "Country",
      "internalCode": "Other internal code",
      "latitude": "Latitude",
      "longitude": "Longitude",
      "name": "Facility name",
      "parentCompany": "Parent business partner",
      "performedActivities": "Performed activities",
      "postalCode": "Postal code",
      "registrationId": "Facility registration IDs",
      "street": "Street"
    },
    "placeholders": {
      "city": "e.g. Dhaka",
      "country": "Select country where the facility is located",
      "internalCode": "e.g. BD-DAK-001 or your internal reference",
      "latitude": "e.g. 48.8566",
      "longitude": "e.g. 2.3522",
      "name": "e.g. Dhaka Cut & Sew Unit A",
      "performedActivities": "e.g. Cutting, sewing, finishing, dyeing",
      "postalCode": "e.g. 1207",
      "registrationId": "e.g. VAT number, CIN, GSTIN, USC",
      "street": "e.g. 221B Baker Street"
    },
    "registrationIdDescriptions": {
      "DUNS": "DUNS: 9-digit number.",
      "EORI": "EORI: country code + 14-digit number.",
      "GLN": "GLN: 13-digit number.",
      "OTHER": "Other: max 32 characters.",
      "RCS": "RCS: RCS + space + company name + space + [A,B] + space + 9-digit number.",
      "VAT": "VAT: country code (e.g., FR) + 2-digit key + 9-digit SIREN number."
    },
    "registrationIdErrors": {
      "DUNS": "DUNS registration ID must be in format: 9-digit number.",
      "EORI": "EORI registration ID must be in format: country code (e.g., FR) + 14-digit number.",
      "GLN": "GLN registration ID must be in format: 13-digit number.",
      "OTHER": "Other registration ID must be less than 32 characters.",
      "RCS": "RCS registration ID must be in format: RCS + space + company name + space + [A,B] + space + 9-digit number.",
      "VAT": "VAT registration ID must be in format: country code (e.g., FR) + 2-digit key + 9-digit SIREN number."
    },
    "tabs": {
      "generalInfo": "Information",
      "location": "Location"
    },
    "tooltips": {
      "address": "Complete address of the facility. Used to identify and trace this location in your records.",
      "city": "City or town where the facility is located.",
      "country": "Country where the facility operates.",
      "internalCode": "Short internal code your team uses to recognize this facility.",
      "latitude": "Optional: latitude of the facility in decimal degrees (e.g. 48.8566).",
      "longitude": "Optional: longitude of the facility in decimal degrees (e.g. 2.3522).",
      "name": "Name you use internally to refer to this facility.",
      "parentCompany": "Company that owns the facility, selected from the list of registered business partners.",
      "performedActivities": "What this facility does (e.g. processing, packaging, storage).",
      "postalCode": "Postal or ZIP code where the facility is located.",
      "registrationId": "Official site identification number (VAT Number, CIN, GSTIN, USC, etc.).",
      "street": "Street number and line for the facility address."
    }
  },
  "productionSites": {
    "buttons": {
      "add": "New"
    },
    "create": {
      "error": "An error occurred while creating the production site",
      "success": {
        "message": "The production site has been created successfully",
        "title": "Production site created"
      }
    },
    "delete": {
      "error": "Error deleting production site",
      "success": {
        "message": "The production site has been deleted successfully",
        "title": "Production site deleted"
      }
    },
    "filters": {
      "country": "Country",
      "internalCode": "Other internal code",
      "isConfidential": "Confidential",
      "isConfidentialFalse": "No",
      "isConfidentialTrue": "Yes",
      "name": "Facility name",
      "nothingFoundMessage": "No results found",
      "performedActivities": "Performed activities",
      "searchPlaceholder": "Search filters",
      "title": "Filters"
    },
    "search": {
      "placeholder": "Search by name or address"
    },
    "sorts": {
      "address": "Location",
      "country": "Country",
      "email": "Email",
      "internalCode": "Other internal code",
      "name": "Name"
    },
    "table": {
      "headers": {
        "address": "Location",
        "certificates": "Certificates",
        "deleted": "Deleted",
        "id": "ID",
        "internalCode": "Other internal code",
        "name": "Facility name",
        "parentCompany": "Parent company",
        "performedActivities": "Performed activities",
        "registrationId": "Facility registration IDs"
      }
    },
    "title": "Production Sites",
    "update": {
      "error": "Error updating production site",
      "success": {
        "message": "The production site has been updated successfully",
        "title": "Production site updated"
      }
    }
  },
  "request": {
    "errors": {
      "generic": "Error"
    }
  }
}
